import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-assets-management',
    templateUrl: './assets-management.component.html',
    styleUrls: ['./assets-management.component.scss'],
})
export class AssetsManagementComponent implements OnInit {
    @Input() search!: string;
    @Output() addFolder = new EventEmitter();
    @Output() onFolderSearch = new EventEmitter<string>();

    constructor() {
    }


    ngOnInit(): void {
    }
}
